<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Приложение 8</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container fr-table">
            <b-table-simple striped hover bordered>
                <thead>
                <b-tr>
                    <b-th>№</b-th>
                    <b-th>АБП</b-th>
                    <b-th>Сведения о проекте государственно-частного партнерства</b-th>
                    <b-th>Год начала выплаты компенсации инвест. затрат по объектам концессии</b-th>
                    <b-th>Меры государственной поддержки</b-th>
                    <b-th>Сумма гос. обязательств по договору</b-th>
                    <b-th>Сумма гос. обязательств по компенсации инвест. затрат по объектам концессии</b-th>
                    <b-th>Остаток непогашенных гос. обязательств на начало периода</b-th>
                    <b-th>Сумма выплат в погашение гос. обязательств за {{ radio_year }} год</b-th>
                    <b-th>Остаток непогашенных гос. обязательств на конец периода</b-th>
                    <b-th>Сумма оплаченных гос. обязательств с начала реализации проекта</b-th>
                    <b-th></b-th>
                </b-tr>
                </thead>
                <b-tbody>
                    <b-tr :style="{backgroundColor: '#E7F6FF'}">
                        <td class="text-center">1</td>
                        <td colspan="11">
                            <div class="bold-label">По договорам концессии</div>
                        </td>
                    </b-tr>
                    <template v-for="(row, rowIndex) in visibleContracts">
                        <!-- Строка 1 -->
                        <b-tr :key="row.id">
                            <td rowspan="4">{{ '1.' + (rowIndex + 1) }}</td>
                            <td rowspan="4">{{ row.abp_name_ru }}</td>
                            <td rowspan="4" class="text-start">
                                <span class="text-primary text-decoration-underline cursor-pointer"
                                    @click="openProjects(row.id, true, true)">{{ row.object_name_ru}} №{{row.contract_number }}<br>
                                    от {{ formatDate(row.contract_date)}}, дата регистрации в казначействе
                                    {{ formatDate(row.registration_date) }}, период выплат:
                                    {{ formatDate(row.period_begin) }} - {{ formatDate(row.period_end) }}</span>
                            </td>
                            <td class="text-center" rowspan="4">{{ row.year_beginning }}</td>

                            <td class="text-left">Компенсация инвестиционных затрат</td>
                            <td class="text-right">{{row.investment_costs}}</td>
                            <td class="text-right">{{row.operating_costs}}</td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputInv8"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputInv8', 'sum8')"/></td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputInv9"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputInv9', 'sum9')"/></td>
                            <td class="text-right">{{row.invCol10}}</td>
                            <td class="text-right">{{row.invCol11}}</td>
                            <td rowspan="4">
                                <b-dropdown v-if="access_level === 2 || access_level === 3" id="dropdown-dropleft"
                                            dropleft class="more">
                                    <template v-slot:button-content>
                                        <i class="icon icon-more"></i>
                                    </template>
                                    <b-dropdown-item @click="openProjects(row.id, true, false)">
                                        Редактировать
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="hideProject(row.id)" class="remove">
                                        Удалить
                                    </b-dropdown-item>
                                </b-dropdown>
                            </td>
                        </b-tr>
                        <b-tr :key="row.id + '.1'" class="text-right">
                            <td class="text-left">Компенсация операционных (эксплуатационных) затрат</td>
                            <td>{{row.operating_costs}}</td>
                            <td>XXXX</td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputOp8"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOp8', 'sum8')"/></td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputOp9"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOp9', 'sum9')"/></td>
                            <td>{{row.opCol10}}</td>
                            <td>{{row.opCol11}}</td>
                        </b-tr>
                        <b-tr :key="row.id + '.2'" class="text-right">
                            <td class="text-left">Прочие выплаты</td>
                            <td>{{row.other_payments}}</td>
                            <td>XXXX</td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right"
                                       :value="row.inputOther8"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOther8', 'sum8')"/></td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputOther9"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOther9', 'sum9')"/></td>
                            <td>{{row.otherCol10}}</td>
                            <td>{{row.otherCol11}}</td>
                        </b-tr>
                        <b-tr :key="row.id + '.3'" class="text-right">
                            <td class="text-left"><b>Итого:</b></td>
                            <td>{{row.investment_costs + row.operating_costs + row.other_payments}}</td>
                            <td>{{row.operating_costs}}</td>
                            <td>{{row.sum8}}</td>
                            <td>{{row.sum9}}</td>
                            <td>{{row.sum10}}</td>
                            <td>{{row.sum11}}</td>
                        </b-tr>
                    </template>
                    <b-tr>
                        <td colspan="12" class="td-add-button">
                            <span class="add-link-button" @click="chooseType('Договор концессии')"><i
                                class="icon icon-plus-circle"></i>Добавить проект</span>
                        </td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>100</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Всего обязательств по договорам концессии, в том числе:</td>
                        <td>{{ totals.investment_costs + totals.operating_costs + totals.other_payments }}</td>
                        <td>{{ totals.investment_costs + totals.operating_costs + totals.other_payments }}</td>
                        <td>{{ totals.sum8 }}</td>
                        <td><span
                            v-if="hasErrorPR8()"
                            :title="'Значение не соответствует контролю: строка 100 + 200, Приложение 8 = строка 022, Форма ПЗ 12.1'"
                            class="warning-icon"
                        >⚠</span>{{ totals.sum9 }}</td>
                        <td>{{ totals.sum8 - totals.sum9}}</td>
                        <td>{{ totals.investment_costs + totals.operating_costs + totals.other_payments - (totals.sum8 - totals.sum9) }}</td>
                        <td rowspan="4"></td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>101</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Компенсация инвестиционных затрат</td>
                        <td>{{ totals.investment_costs }}</td>
                        <td>{{ totals.investment_costs }}</td>
                        <td>{{ totals.inputInv8 }}</td>
                        <td>{{ totals.inputInv9 }}</td>
                        <td>{{ totals.inputInv8 - totals.inputInv9}}</td>
                        <td>{{ totals.investment_costs - (totals.inputInv8 - totals.inputInv9) }}</td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>102</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Компенсация операционных (эксплуатационных) затрат</td>
                        <td>{{ totals.operating_costs }}</td>
                        <td>XXXX</td>
                        <td>{{ totals.inputOp8 }}</td>
                        <td>{{ totals.inputOp9 }}</td>
                        <td>{{ totals.inputOp8 - totals.inputOp9}}</td>
                        <td>{{ totals.operating_costs - (totals.inputOp8 - totals.inputOp9) }}</td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>103</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Прочие выплаты</td>
                        <td>{{ totals.other_payments }}</td>
                        <td>XXXX</td>
                        <td>{{ totals.inputOther8 }}</td>
                        <td>{{ totals.inputOther9 }}</td>
                        <td>{{ totals.inputOther8 - totals.inputOther9}}</td>
                        <td>{{ totals.other_payments - (totals.inputOther8 - totals.inputOther9) }}</td>
                    </b-tr>
                    <b-tr :style="{backgroundColor: '#E7F6FF'}">
                        <td class="text-center">2</td>
                        <td colspan="11">
                            <div class="bold-label">По прочим договорам государственно-частного партнерства</div>
                        </td>
                    </b-tr>
                    <template v-for="(row, rowIndex) in visiblePartnerships">
                        <!-- Строка 1 -->
                        <b-tr :key="row.id">
                            <td rowspan="4">{{ '2.' + (rowIndex + 1) }}</td>
                            <td rowspan="4">{{ row.abp_name_ru }}</td>
                            <td rowspan="4" class="text-start">
                                <span class="text-primary text-decoration-underline cursor-pointer"
                                      @click="openProjects(row.id, true, true)">{{ row.object_name_ru}} №{{row.contract_number }}<br>
                                    от {{ formatDate(row.contract_date)}}, дата регистрации в казначействе
                                    {{ formatDate(row.registration_date) }}, период выплат:
                                    {{ formatDate(row.period_begin) }} - {{ formatDate(row.period_end) }}</span>
                            </td>
                            <td class="text-center" rowspan="4">{{ row.year_beginning }}</td>

                            <td class="text-left">Компенсация инвестиционных затрат</td>
                            <td class="text-right">{{row.investment_costs}}</td>
                            <td class="text-right">XXXX</td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputInv8"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputInv8', 'sum8')"/></td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputInv9"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputInv9', 'sum9')"/></td>
                            <td class="text-right">{{row.invCol10}}</td>
                            <td class="text-right">{{row.invCol11}}</td>
                            <td rowspan="4">
                                <b-dropdown v-if="access_level === 2 || access_level === 3" id="dropdown-dropleft"
                                            dropleft class="more">
                                    <template v-slot:button-content>
                                        <i class="icon icon-more"></i>
                                    </template>
                                    <b-dropdown-item @click="openProjects(row.id, true, false)">
                                        Редактировать
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="hideProject(row.id)" class="remove">
                                        Удалить
                                    </b-dropdown-item>
                                </b-dropdown>
                            </td>
                        </b-tr>
                        <b-tr :key="row.id + '.1'" class="text-right">
                            <td class="text-left">Компенсация операционных (эксплуатационных) затрат</td>
                            <td>{{row.operating_costs}}</td>
                            <td>XXXX</td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputOp8"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOp8', 'sum8')"/></td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputOp9"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOp9', 'sum9')"/></td>
                            <td>{{row.opCol10}}</td>
                            <td>{{row.opCol11}}</td>
                        </b-tr>
                        <b-tr :key="row.id + '.2'" class="text-right">
                            <td class="text-left">Прочие выплаты</td>
                            <td>{{row.other_payments}}</td>
                            <td>XXXX</td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right"
                                       :value="row.inputOther8"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOther8', 'sum8')"/></td>
                            <td><input type="number" class="form-control no-spinner" style="text-align: right;"
                                       :value="row.inputOther9"
                                       :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                       :disabled="access_level === 1 || !actualVersion"
                                       @blur="blurInput($event, row, 'inputOther9', 'sum9')"/></td>
                            <td>{{row.otherCol10}}</td>
                            <td>{{row.otherCol11}}</td>
                        </b-tr>
                        <b-tr :key="row.id + '.3'" class="text-right">
                            <td class="text-left"><b>Итого:</b></td>
                            <td>{{row.investment_costs + row.operating_costs + row.other_payments}}</td>
                            <td>XXXX</td>
                            <td>{{row.sum8}}</td>
                            <td>{{row.sum9}}</td>
                            <td>{{row.sum10}}</td>
                            <td>{{row.sum11}}</td>
                        </b-tr>
                    </template>
                    <b-tr>
                        <td colspan="12" class="td-add-button">
                            <span class="add-link-button" @click="chooseType('Договор государственно-частного партнерства')"><i
                                class="icon icon-plus-circle"></i>Добавить проект</span>
                        </td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>200</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Всего обязательств по прочим договорам государственно-частного партнерства, в том числе:</td>
                        <td>{{ totals_part.investment_costs + totals_part.operating_costs + totals_part.other_payments }}</td>
                        <td>XXXX</td>
                        <td>{{ totals_part.sum8 }}</td>
                        <td><span
                            v-if="hasErrorPR8()"
                            :title="'Значение не соответствует контролю: строка 100 + 200, Приложение 8 = строка 020, Форма Таблица 1.16 ПД-МБ'"
                            class="warning-icon"
                        >⚠</span>{{ totals_part.sum9 }}</td>
                        <td>{{ totals_part.sum8 - totals_part.sum9}}</td>
                        <td>{{ totals_part.investment_costs + totals_part.operating_costs + totals_part.other_payments - (totals_part.sum8 - totals_part.sum9) }}</td>
                        <td rowspan="4"></td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>201</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Компенсация инвестиционных затрат</td>
                        <td>{{ totals_part.investment_costs }}</td>
                        <td>XXXX</td>
                        <td>{{ totals_part.inputInv8 }}</td>
                        <td>{{ totals_part.inputInv9 }}</td>
                        <td>{{ totals_part.inputInv8 - totals_part.inputInv9}}</td>
                        <td>{{ totals_part.investment_costs - (totals_part.inputInv8 - totals_part.inputInv9) }}</td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>202</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Компенсация операционных затрат</td>
                        <td>{{ totals_part.operating_costs }}</td>
                        <td>XXXX</td>
                        <td>{{ totals_part.inputOp8 }}</td>
                        <td>{{ totals_part.inputOp9 }}</td>
                        <td>{{ totals_part.inputOp8 - totals_part.inputOp9}}</td>
                        <td>{{ totals_part.operating_costs - (totals_part.inputOp8 - totals_part.inputOp9) }}</td>
                    </b-tr>
                    <b-tr class="text-right">
                        <td>203</td>
                        <td></td>
                        <td></td>
                        <td class="text-left" colspan="2">Прочие выплаты</td>
                        <td>{{ totals_part.other_payments }}</td>
                        <td>XXXX</td>
                        <td>{{ totals_part.inputOther8 }}</td>
                        <td>{{ totals_part.inputOther9 }}</td>
                        <td>{{ totals_part.inputOther8 - totals_part.inputOther9}}</td>
                        <td>{{ totals_part.other_payments - (totals_part.inputOther8 - totals_part.inputOther9) }}</td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-modal id="project-modal"
                     ref="modalRef"
                     size="lg"
                     centered
                     modal-class="multiselect-modal modal-table"
            >
                <template #modal-header="{ close }">
                    <!-- Emulate built in modal header close button action -->
                    <div class="title">Проекты</div>
                    <i class="icon icon-close" @click="close()"></i>
                </template>
                <div class="card-modal-multiselect">
                    <b-input-group size="sm" class="mb-2 search-in-modal">
                        <b-form-input type="search" class="npa-input" placeholder="Поиск" v-model="searchQuery"/>
                    </b-input-group>
                    <br>
                    <div class="d-flex align-items-center">
                        <!-- Чекбокс -->
                        <b-form-checkbox v-model="selectAll" @change="toggleAll" class="mr-3">
                            <span class="small">Выбрать все</span>
                        </b-form-checkbox>

                        <!-- Радиокнопки -->
                        <b-form-radio-group style="margin-left: 70px"
                            v-model="project_act"
                            :options="projectActList">
                        </b-form-radio-group>
                    </div>
                    <div class="card-modal-multiselect-content">
                        <b-form-group>
                            <div
                                v-for="option in filteredContractOptions"
                                :key="option.id"
                                class="d-flex align-items-center mb-2">
                                <b-form-checkbox
                                    v-model="selectedProject"
                                    :value="option.id"
                                    class="flex-grow-1">{{ option.object_name_ru }} №{{ option.contract_number }}
                                </b-form-checkbox>
                                <div class="ml-3">
                                    <span
                                        class="mr-2 text-primary cursor-pointer"
                                        @click="openProjects(option.id, true, false)">изменить
                                    </span>
                                    <span
                                        class="text-danger cursor-pointer"
                                        @click="deleteProject(option.id)">удалить
                                    </span>
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                </div>
                <template #modal-footer>
                    <div>
                        <b-button
                            variant="success"
                            size="sm"
                            class="mr-2"
                            @click="addProject"><i class="icon icon-plus-circle"></i>Добавить проект
                        </b-button>
                    </div>
                    <div>
                        <b-button
                            variant="primary"
                            size="sm"
                            class="mr-2"
                            @click="openProjects('', false, false)"><i class="icon icon-plus-circle"></i>Создать проект
                        </b-button>
                        <b-button
                            variant="secondary"
                            size="sm"
                            @click="$root.$emit('bv::hide::modal', 'project-modal')"
                        >Отмена
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal id="create-pr-modal"
                     ref="modalRef"
                     size="lg"
                     centered
                     modal-class="multiselect-modal modal-table"
            >
                <template #modal-header="{ close }">
                    <!-- Emulate built in modal header close button action -->
                    <div class="title">Сведения о проекте</div>
                    <i class="icon icon-close" @click="close()"></i>
                </template>
                <div class="card-modal-multiselect">
                    <b-form-group label="Тип договора" label-cols="3" class="m-0 form-group-divider label-bold">
                       <span>{{
                               this.contract_type === 'partnership'
                                   ? 'Договор государственно-частного партнерства'
                                   : this.contract_type === 'concession'
                                       ? 'Договор концессии' : this.contract_type }}
                    </span>
                    </b-form-group>
                    <b-form-group label="Название проекта" label-cols="3" class="m-0 form-group-divider label-bold">
                        <b-form-input v-model="agreedName"
                                      :preselect="isEdit ? this.isEditItem.object_name_ru : agreedName"
                                      :readonly="isView"
                                      :placeholder="isEdit ?  this.isEditItem.object_name_ru : 'Введите наименование проекта'"/>
                    </b-form-group>
                    <b-form-group label="Номер договора" label-cols="3" class="m-0 form-group-divider label-bold">
                        <b-form-input v-model="contract_num"
                                      :preselect="isEdit ? this.isEditItem.contract_number : contract_num"
                                      :readonly="isView"
                                      :placeholder="isEdit ? `${isEditItem.contract_number}` : 'Введите номер'"
                        />
                    </b-form-group>
                    <b-form-group label="АБП" label-cols="3" class="m-0 form-group-divider label-bold">
                        <multiselect
                            :options="abpList"
                            v-model="selectedAbp"
                            label="text"
                            :disabled="isView"
                            :preselect="isEdit ? this.isEditItem.abp_name_ru : selectedAbp"
                            :placeholder="isEdit ? `${this.isEditItem.abp_name_ru}` : 'Выберите АБП'"/>
                    </b-form-group>
                    <br>
                    <div class="m-0 d-flex form-group-divider label-bold">
                        <b-form-group
                            label="Дата заключения договора:"
                            label-for="contractDate"
                            label-size="sm"
                            class="m-0 d-flex align-items-center mr-5 bold"
                            style="flex: 1;"
                        >
                            <date-picker
                                id="contractDate"
                                v-model="contractDate"
                                format="DD.MM.YYYY"
                                :disabled="isView"
                                :preselect="isEdit ? this.isEditItem.contract_date : contractDate"
                                :placeholder="isEdit ?  this.isEditItem.contract_date : 'Выберите дату'"
                            />
                        </b-form-group>

                        <b-form-group
                            label="Дата регистрации в казначействе:"
                            label-for="registrationDate"
                            label-size="sm"
                            class="m-0 d-flex align-items-center bold"
                            style="flex: 1;"
                        >
                            <date-picker
                                id="treasureDate"
                                :preselect="isEdit ? this.isEditItem.registration_date : registrationDate"
                                :placeholder="isEdit ?  this.isEditItem.registration_date : 'Выберите дату'"
                                v-model="registrationDate"
                                format="DD.MM.YYYY"
                                :disabled="isView"
                            />
                        </b-form-group>
                    </div>
                    <b-form-group label="Год начала выплат компенсации инвест. затрат:" label-cols="6" class="m-0 form-group-divider label-bold">
                        <multiselect
                            v-model="contractYear"
                            :options="years"
                            label="text"
                            :disabled="isView"
                            :preselect="isEdit ? this.isEditItem.year_beginning : contractYear"
                            :placeholder="isEdit ? `${this.isEditItem.year_beginning}` : 'Выберите год'"
                        />
                    </b-form-group>
                    <b-form-group label="Период выплат" label-cols="3" class="m-0 form-group-divider label-bold">
                        <div class="d-flex align-items-center">
                            <span class="mr-1">с</span>
                            <date-picker
                                v-model="fromDate"
                                format="DD.MM.YYYY"
                                :disabled="isView"
                                :preselect="isEdit ? this.isEditItem.period_begin : fromDate"
                                :placeholder="isEdit ?  this.isEditItem.period_begin : 'Выберите дату'"
                                class="mr-1"
                            />
                            <span class="mr-1">по</span>
                            <date-picker
                                v-model="toDate"
                                :disabled="isView"
                                :preselect="isEdit ? this.isEditItem.period_end : toDate"
                                :placeholder="isEdit ?  this.isEditItem.period_end : 'Выберите дату'"
                                format="DD.MM.YYYY"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group
                        label="Дата окончания:"
                        label-cols="3" class="m-0 form-group-divider label-bold"
                    >
                        <date-picker
                            id="endDate"
                            v-model="endDate"
                            format="DD.MM.YYYY"
                            :disabled="isView"
                            :preselect="isEdit ? this.isEditItem.end_date : endDate"
                            :placeholder="isEdit ?  this.isEditItem.end_date : 'Выберите дату'"
                        />
                    </b-form-group>
                    <br>
                    <b-form-group label="Сумма государственных обязательств по договору:" label-cols="6"></b-form-group>
                    <b-form-group label="Компенсация инвестиционных затрат" label-cols="6" class="m-0 form-group-divider label-bold">
                        <b-form-input v-model.number="investment_costs"
                                      :preselect="isEdit ? this.isEditItem.investment_costs : investment_costs"
                                      :readonly="isView"
                                      :placeholder="isEdit ? (isEditItem.investment_costs !== null ? `${isEditItem.investment_costs}` : '') : 'Введите данные'"/>
                    </b-form-group>
                    <b-form-group label="Компенсация операционных затрат" label-cols="6" class="m-0 form-group-divider label-bold">
                        <b-form-input v-model.number="operating_costs"
                                      :preselect="isEdit ? this.isEditItem.operating_costs : operating_costs"
                                      :readonly="isView"
                                      :placeholder="isEdit ? (isEditItem.operating_costs !== null ? `${isEditItem.operating_costs}` : '') : 'Введите данные'"/>
                    </b-form-group>
                    <b-form-group label="Прочие выплаты" label-cols="6" class="m-0 form-group-divider label-bold">
                        <b-form-input v-model.number="other_costs"
                                      :preselect="isEdit ? this.isEditItem.other_payments : other_costs"
                                      :readonly="isView"
                                      :placeholder="isEdit ? (isEditItem.other_payments !== null ? `${isEditItem.other_payments}` : '') : 'Введите данные'"/>
                    </b-form-group>
                    <b-form-group label="Итого" label-cols="6" class="m-0 form-group-divider label-bold">
                        <b-form-input readonly :value="total_costs"
                        />
                    </b-form-group>
                </div>
                <template #modal-footer>
                    <div>
                        <b-button
                            v-if="!isView"
                            variant="primary"
                            size="sm"
                            class="mr-2"
                        @click="SaveProject">Сохранить
                        </b-button>
                        <b-button
                            v-if="!isView"
                            variant="secondary"
                            size="sm"
                            @click="$root.$emit('bv::hide::modal', 'create-pr-modal')"
                        >Отмена
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import DatePicker from 'vue2-datepicker';
import {Ax} from "@/utils";
import moment from "moment";

export default {
    name: 'forecast-uo-app8',
    components: {'loading': VueElementLoading,  DatePicker},
    props: {
        year: Number,
        region: String,
        version: String,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        showInc: Boolean,
        table_num: String,
        radio_year: Number,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            tableFields: [
                {
                    key: 'code',
                    label: '№',
                    rowspan: 2
                },
                {
                    key: 'pkfo_2_code',
                    label: 'Строка из прогнозного консолидированного отчета о результатах финансовой деятельности',
                    rowspan: 2
                },
                {
                    key: 'spf',
                    label: 'Специфика экономической классификации Единой бюджетной классификации ',
                    rowspan: 2
                },
                {
                    key: 'name_ru',
                    label: 'Сумма по строке прогнозного отчета о результатах финансовой деятельности',
                    rowspan: 2
                },
                {
                    key: 'value',
                    label: 'Оценка*, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'forecast',
                    label: 'Прогноз, ТЫС.ТЕҢГЕ',
                    colspan: 3
                }],
            formApp6: [],
            tableCheck: false,
            table_number: null,
            table_name: null,
            repdate: null,
            openRows: {},
            inputValues: [],
            showModal: false,
            filteredComments: [],
            comments_text: '',
            previousCommentText: [],
            searchQuery: '',
            selectAll: false,
            project_act: 0,
            projectActList: [
                {value: 0, text: 'Показать все проекты'},
                {value: 1, text: 'Показать только актуальные проекты'}
            ],
            contractList: [],
            partnershipList: [],
            selectedProject: [],
            contract_type: null,
            agreedName: null,
            contract_num: null,
            selectedAbp: null,
            abpList: [],
            contractDate: new Date().toISOString().split('T')[0],
            registrationDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            contractYear: null,
            years: [
                { value: 2025, text: '2025' },
                { value: 2024, text: '2024' },
                { value: 2023, text: '2023' },
                { value: 2022, text: '2022' }
            ],
            investment_costs: null,
            operating_costs: null,
            other_costs: null,
            isEdit: false,
            isView: false,
            isEditItem: {}
        }
    },
    async mounted() {
        await this.getProjectList(this.radio_year);
        await this.loadAbp();
    },
    watch: {
        filteredContractOptions: {
            immediate: true,
            handler(newVal) {
                // в selectedProject кладём только те id, где view = true
                this.selectedProject = newVal
                    .filter(row => row.view === true)
                    .map(row => row.id);
            }
        },
        radio_year() {
            this.inputValues = [];
        }
    },
    computed: {
        visibleContracts() {
            return this.contractList.filter(row => {
                if (!row.view) return false;

                // если даты нет — показываем
                if (!row.end_date) return true;

                const endYear = new Date(row.end_date).getFullYear();
                const selectedYear = Number(this.radio_year);

                return selectedYear <= endYear;
            });
        },
        visiblePartnerships() {
            return this.partnershipList.filter(row => {
                if (!row.view) return false;

                // если даты нет — показываем
                if (!row.end_date) return true;

                const endYear = new Date(row.end_date).getFullYear();
                const selectedYear = Number(this.radio_year);

                return selectedYear <= endYear;
            });
        },
        forecastProps() {
            return {
                year: this.year,
                region: this.region,
                region_name: this.region_name,
                version: this.version,
                version_name: this.version_name,
                dataType: this.dataType,
                obl: this.obl,
                actualVersion: this.actualVersion,
                access_level: this.access_level
            };
        },
        filteredContractOptions() {
            let source = this.contract_type === 'Договор концессии'
                ? this.contractList
                : this.partnershipList;

            // фильтр по поиску
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                source = source.filter(option =>
                    (option.object_name_ru && option.object_name_ru.toLowerCase().includes(query)) ||
                    (option.contract_number && option.contract_number.toString().toLowerCase().includes(query))
                );
            }

            // фильтр по актуальности проекта
            if (this.project_act === 1) {
                const today = new Date();
                source = source.filter(row => {
                    const begin = new Date(row.period_begin);
                    const end   = new Date(row.period_end);
                    return begin <= today && today <= end;
                });
            }

            return source;
        },
        total_costs() {
            if (this.isEdit) {
                const inv = parseFloat(this.investment_costs) || parseFloat(this.isEditItem.investment_costs) || 0;
                const op = parseFloat(this.operating_costs) || parseFloat(this.isEditItem.operating_costs) || 0;
                const oth = parseFloat(this.other_costs) || parseFloat(this.isEditItem.other_payments) || 0;
                return inv + op + oth;
            } else {
                const inv = parseFloat(this.investment_costs) || 0;
                const op = parseFloat(this.operating_costs) || 0;
                const oth = parseFloat(this.other_costs) || 0;
                return inv + op + oth;
            }
        },
        totals() {
            return this.visibleContracts.reduce((acc, row) => {
                acc.investment_costs += parseFloat(row.investment_costs) || 0;
                acc.operating_costs += parseFloat(row.operating_costs) || 0;
                acc.other_payments += parseFloat(row.other_payments) || 0;

                acc.inputInv8 += parseFloat(row.inputInv8) || 0;
                acc.inputInv9 += parseFloat(row.inputInv9) || 0;
                acc.inputOp8 += parseFloat(row.inputOp8) || 0;
                acc.inputOp9 += parseFloat(row.inputOp9) || 0;
                acc.inputOther8 += parseFloat(row.inputOther8) || 0;
                acc.inputOther9 += parseFloat(row.inputOther9) || 0;

                acc.sum8 += parseFloat(row.sum8) || 0;
                acc.sum9 += parseFloat(row.sum9) || 0;
                acc.sum10 += parseFloat(row.sum10) || 0;
                acc.sum11 += parseFloat(row.sum11) || 0;

                acc.invCol10 += parseFloat(row.invCol10) || 0;
                acc.invCol11 += parseFloat(row.invCol11) || 0;
                acc.opCol10 += parseFloat(row.opCol10) || 0;
                acc.opCol11 += parseFloat(row.opCol11) || 0;
                acc.otherCol10 += parseFloat(row.otherCol10) || 0;
                acc.otherCol11 += parseFloat(row.otherCol11) || 0;

                return acc;
            }, {
                investment_costs: 0,
                operating_costs: 0,
                other_payments: 0,

                inputInv8: 0,
                inputInv9: 0,
                inputOp8: 0,
                inputOp9: 0,
                inputOther8: 0,
                inputOther9: 0,

                sum8: 0,
                sum9: 0,
                sum10: 0,
                sum11: 0,

                invCol10: 0,
                invCol11: 0,
                opCol10: 0,
                opCol11: 0,
                otherCol10: 0,
                otherCol11: 0
            });
        },
        totals_part() {
            return this.visiblePartnerships.reduce((acc, row) => {
                acc.investment_costs += parseFloat(row.investment_costs) || 0;
                acc.operating_costs += parseFloat(row.operating_costs) || 0;
                acc.other_payments += parseFloat(row.other_payments) || 0;

                acc.inputInv8 += parseFloat(row.inputInv8) || 0;
                acc.inputInv9 += parseFloat(row.inputInv9) || 0;
                acc.inputOp8 += parseFloat(row.inputOp8) || 0;
                acc.inputOp9 += parseFloat(row.inputOp9) || 0;
                acc.inputOther8 += parseFloat(row.inputOther8) || 0;
                acc.inputOther9 += parseFloat(row.inputOther9) || 0;

                acc.sum8 += parseFloat(row.sum8) || 0;
                acc.sum9 += parseFloat(row.sum9) || 0;
                acc.sum10 += parseFloat(row.sum10) || 0;
                acc.sum11 += parseFloat(row.sum11) || 0;

                acc.invCol10 += parseFloat(row.invCol10) || 0;
                acc.invCol11 += parseFloat(row.invCol11) || 0;
                acc.opCol10 += parseFloat(row.opCol10) || 0;
                acc.opCol11 += parseFloat(row.opCol11) || 0;
                acc.otherCol10 += parseFloat(row.otherCol10) || 0;
                acc.otherCol11 += parseFloat(row.otherCol11) || 0;

                return acc;
            }, {
                investment_costs: 0,
                operating_costs: 0,
                other_payments: 0,

                inputInv8: 0,
                inputInv9: 0,
                inputOp8: 0,
                inputOp9: 0,
                inputOther8: 0,
                inputOther9: 0,

                sum8: 0,
                sum9: 0,
                sum10: 0,
                sum11: 0,

                invCol10: 0,
                invCol11: 0,
                opCol10: 0,
                opCol11: 0,
                otherCol10: 0,
                otherCol11: 0
            });
        }
    },
    methods: {
        hasErrorPR8() {
            return this.checkDataList.find(item => {
                if (item.checked_form !== 'PR8' || item.row_code !== '7.1') {
                    return false;
                }

                // проверяем все возможные поля
                const fieldMap = {
                    evaluation: this.year - 1,
                    forecast_1: this.year,
                    forecast_2: this.year + 1,
                    forecast_3: this.year + 2,
                };

                // ищем, есть ли совпадение
                return Object.entries(fieldMap).some(([field, year]) => {
                    return item[field] && year === this.radio_year;
                });
            });
        },
        toggleAll() {
            this.selectedProject = this.selectAll
                ? this.filteredContractOptions.map(o => o.id)
                : [];
        },
        formatDate(date) {
            if (date !== null){
                return new Date(date).toLocaleDateString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        async addProject(){
            const item = [{
                selectedList: this.selectedProject
            }]
            try {
                const response = await fetch('/api-py/add_project_gchp_contracts', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(item)
                });
                const result = await response.json();
                if (response.status === 200 && result.result === 'success') {
                    this.showModal = false;
                    this.isSave = false;
                    this.makeToast('success', 'Сообщение', 'Проект добавлен');
                    await this.getProjectList(this.radio_year);
                    this.$bvModal.hide('project-modal');
                } else {
                    if (result.result === 'error') {
                        throw 'Ошибка добавления';
                    }
                }
            } catch (e) {
                this.makeToast('danger', 'Предупреждение', e.toString());
            } finally {
                this.isLoad = false;
            }

        },
        blurInput(event, row, field, sumField) {
            const value = parseFloat(event.target.value) || 0;
            this.$set(row, field, value);

            let total = 0;

            if (sumField === 'sum8') {
                total =
                    (parseFloat(row.inputInv8) || 0) +
                    (parseFloat(row.inputOp8) || 0) +
                    (parseFloat(row.inputOther8) || 0);
            } else if (sumField === 'sum9') {
                total =
                    (parseFloat(row.inputInv9) || 0) +
                    (parseFloat(row.inputOp9) || 0) +
                    (parseFloat(row.inputOther9) || 0);
            }
            this.$set(row, sumField, total);

            const invCol10 = (parseFloat(row.inputInv8) || 0) - (parseFloat(row.inputInv9) || 0);
            this.$set(row, 'invCol10', invCol10);
            this.$set(row, 'invCol11', row.investment_costs - invCol10);

            const opCol10 = (parseFloat(row.inputOp8) || 0) - (parseFloat(row.inputOp9) || 0);
            this.$set(row, 'opCol10', opCol10);
            this.$set(row, 'opCol11', row.operating_costs - opCol10);

            const otherCol10 = (parseFloat(row.inputOther8) || 0) - (parseFloat(row.inputOther9) || 0);
            this.$set(row, 'otherCol10', otherCol10);
            this.$set(row, 'otherCol11', row.other_payments - otherCol10);

            this.$set(row, 'sum10', invCol10 + opCol10 + otherCol10);
            this.$set(row, 'sum11', (row.investment_costs - invCol10) + (row.operating_costs - opCol10) + (row.other_payments - otherCol10));

            let costType = null;
            let paid = 0;
            let remined = 0;
            let cumulative_paid = 0;

            if (field === 'inputInv8' || field === 'inputInv9') {
                costType = 'investment';
                paid = parseFloat(row.inputInv9) || 0;
                remined = invCol10;
                cumulative_paid = row.investment_costs - invCol10;
            }
            else if (field === 'inputOp8' || field === 'inputOp9') {
                costType = 'operating';
                paid = parseFloat(row.inputOp9) || 0;
                remined = opCol10;
                cumulative_paid = row.operating_costs - opCol10;
            }
            else if (field === 'inputOther8' || field === 'inputOther9') {
                costType = 'other';
                paid = parseFloat(row.inputOther9) || 0;
                remined = otherCol10;
                cumulative_paid = row.other_payments - otherCol10;
            }

            if (costType) {
                const existingEntryIndex = this.inputValues.findIndex(
                    entry => entry.id === row.id && entry.cost_type === costType
                );

                if (existingEntryIndex !== -1) {
                    this.$set(this.inputValues[existingEntryIndex], 'paid', paid);
                    this.$set(this.inputValues[existingEntryIndex], 'remined', remined);
                    this.$set(this.inputValues[existingEntryIndex], 'cumulative_paid', cumulative_paid);
                } else {
                    const newEntry = { id: row.id, cost_type: costType, paid, remined, cumulative_paid };
                    this.inputValues.push(newEntry);
                }
            }
        },
        async loadAbp() {
            if (this.region !== null) {
                try {
                    const response = await fetch('/api-py/get_abp_by_region_user_id/' + this.region + '/' + this.$store.getters.user_uuid + '/' + 0);
                    if (response.status === 200) {
                        this.abpList = await response.json();
                    }
                } catch (error) {
                    this.makeToast('danger', 'Ошибка запроса АБП', error.toString());
                }
            }
        },
        openProjects(option, isEdit, view){
            this.isEdit = isEdit;
            this.isView = view;
            ['agreedName', 'contract_num', 'selectedAbp', 'contractYear', 'contractDate',
                'registrationDate', 'fromDate', 'toDate', 'investment_costs',
                'operating_costs', 'other_costs', 'endDate'].forEach(key => {
                this[key] = null;
            });
            this.isEditItem = this.contractList.find(item => item.id === option)
                || this.partnershipList.find(item => item.id === option);

            if (this.isEditItem) {
                this.contract_type = this.isEditItem.contract_type;
            }

            this.$bvModal.hide('project-modal');
            this.$bvModal.show('create-pr-modal');
        },
        chooseType(type){
            this.contract_type = type;
            this.$bvModal.show('project-modal');
        },
        async getProjectList(year) {
            const response = await fetch('/api-py/get_gchp_contracts/' + this.version + '/' + year + '/' + this.year + '/' + this.region);
            const data = await response.json();
            this.contractList = data.concession;
            this.partnershipList = data.partnership;
        },
        async SaveProject() {
            if (this.contract_type !== null){
                if (!this.endDate && !this.isEditItem?.end_date) {
                    this.$bvToast.toast(
                        'Пожалуйста, заполните дату окончания договора',
                        {
                            title: 'Обязательное поле',
                            variant: 'warning',
                            solid: true,
                            toaster: 'b-toaster-top-center'
                        }
                    );
                    return;
                }
                this.project = [];
                const item = Object.assign({});
                let consType;
                if (this.contract_type === 'Договор концессии' || this.contract_type === 'concession') {
                    consType = 'concession';
                } else {
                    consType = 'partnership';
                }
                const source = consType === 'concession' ? this.contractList : this.partnershipList;

                // Проверка на уникальность имени в пределах региона
                const isDuplicate = source.some(p =>
                    p.object_name_ru?.trim().toLowerCase() === this.agreedName?.trim().toLowerCase() &&
                    p.region === this.region
                );
                if (isDuplicate) {
                    this.$bvToast.toast(
                        `Проект с таким названием уже существует: ${this.agreedName}`,
                        { title: 'Ошибка', variant: 'warning', solid: true, toaster: 'b-toaster-top-center' }
                    );
                    return; // не добавляем проект
                }
                this.$set(item, 'id', this.isEditItem?.id || null);
                this.$set(item, 'contract_type', consType);
                this.$set(item, 'region', this.region);
                this.$set(item, 'abp', this.selectedAbp?.abp || this.isEditItem.abp);
                this.$set(item, 'object_name_ru', this.agreedName || this.isEditItem?.object_name_ru || null);
                this.$set(item, 'object_name_kk', this.agreedName || this.isEditItem?.object_name_kk || null);
                this.$set(item, 'contract_date', this.contractDate
                        ? moment(this.contractDate).format('YYYY-MM-DD')
                        : this.isEditItem?.contract_date || null);
                this.$set(item, 'end_date', this.endDate
                    ? moment(this.endDate).format('YYYY-MM-DD')
                    : this.isEditItem?.end_date || null);
                this.$set(item, 'contract_number',  this.contract_num || this.isEditItem?.contract_number || null);
                this.$set(item, 'registration_date', this.registrationDate
                        ? moment(this.registrationDate).format('YYYY-MM-DD')
                        : this.isEditItem?.registration_date || null);
                this.$set(item, 'period_begin', this.fromDate
                        ? moment(this.fromDate).format('YYYY-MM-DD')
                        : this.isEditItem?.period_begin || null);
                this.$set(item, 'period_end', this.toDate
                        ? moment(this.toDate).format('YYYY-MM-DD')
                        : this.isEditItem?.period_end || null);
                this.$set(item, 'year_beginning', this.contractYear
                        ? moment(this.contractYear).format('YYYY')
                        : this.isEditItem?.year_beginning || null);
                this.$set(item, 'investment_costs', this.investment_costs || this.isEditItem?.investment_costs || null);
                this.$set(item, 'operating_costs', this.operating_costs || this.isEditItem?.operating_costs || null);
                this.$set(item, 'other_payments', this.other_costs || this.isEditItem?.other_payments || null);
                this.isLoad = true;
                this.project.push(item);
                try {
                    const response = await fetch('/api-py/save_project_to_gchp_contracts', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.project)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.showModal = false;
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Проект сохранен');
                        await this.getProjectList(this.radio_year);
                        this.$bvModal.hide('create-pr-modal');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async SaveData() {
            if (this.inputValues.length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'code_form', 'PR8');
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'radio_year', this.radio_year);
                this.$set(item, 'pkfo_type', 'uo');
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_gchp_data', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }

        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, cur_year: this.year, region: this.region, version: this.version, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_uo_download_app8/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Приложение 8.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        async hideProject(id){
            try {
                const response = await fetch('/api-py/delete_project_gchp_contracts', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify({ id })
                });
                const result = await response.json();
                if (response.status === 200 && result.result === 'success') {
                    this.showModal = false;
                    this.isSave = false;
                    this.makeToast('success', 'Сообщение', 'Проект удален');
                    await this.getProjectList(this.radio_year);
                } else {
                    if (result.result === 'error') {
                        throw 'Ошибка добавления';
                    }
                }
            } catch (e) {
                this.makeToast('danger', 'Предупреждение', e.toString());
            } finally {
                this.isLoad = false;
            }
        },
        async delete(id) {
            try {
                const response = await fetch(`/api-py/delete-data-from-gchp_contracts?id=${id}`, {
                    method: 'DELETE'
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    this.makeToast('success', 'Сообщение', 'Запись удалена');
                    this.$bvModal.hide('project-modal');
                    await this.getProjectList(this.radio_year);
                }
            } catch {
                this.makeToast('danger', 'Предупреждение', 'Ошибка удаления данных');
            }
        }, // удаление данных
        deleteProject(id) {
            const project = this.filteredContractOptions.find(p => p.id === id);

            // Проверяем: если проект используется (view = true), не даём удалить
            if (project && project.view === true) {
                this.$bvModal.msgBoxOk(
                    'Проект нельзя удалить, так как он используется.',
                    {
                        title: 'Удаление запрещено',
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'ОК',
                        footerClass: 'p-2',
                        centered: true
                    }
                );
                return;
            }

            // Если проект не используется → обычное подтверждение удаления
            this.$bvModal.msgBoxConfirm(
                'Удаленная запись не подлежит восстановлению. Вы уверены?',
                {
                    title: 'Подтверждение',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Да',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.delete(id); // вызываем метод удаления
                    }
                })
                .catch(error => {
                    this.makeToast('danger', 'Ошибка удаления', error.toString());
                });
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>
